import CustomAxios from "..";

export const fetchUsersProfile = async (params) => { 
  try {
    const response = await CustomAxios.get("users",{params});
    return response.data;
  } catch (error) {
    console.error("Error updating plan:", error.message || error);
    throw new Error("Failed to update the plan. Please try again.");
  }
};

export const updateisOnlineUser = async (id,formData) => {
  try {
    const response = await CustomAxios.put(
      `users/${id}/update-online-status`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
};

export const StatusChangeUserById = async (id,formData) => {
  try {
    const response = await CustomAxios.put(
      `users/${id}/subscription`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
};

export const fetchUserById = async (id) => {
  try {
    const response = await CustomAxios.get(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching user with ID ${id}:`, error.message || error);
    throw new Error("Failed to fetch user by ID. Please try again.");
  }
};
export const fetchCurrentWorkout = async (userId) => {
  try {
    const response = await CustomAxios.get(`user-plans/${userId}`);
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching plans for user with userId ${userId}:`,
      error.message || error
    );
    throw new Error("Failed to fetch user plans. Please try again.");
  }
};
export const fetchUserSummaryWithFilters = async (userId, filter) => {
  try {
    const response = await CustomAxios.get(
      `/user-plans/summary/${userId}/filters`,
      {
        params: { filter },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching user summary with filters for userId ${userId}:`,
      error.message || error
    );
    throw new Error(
      "Failed to fetch user summary with filters. Please try again."
    );
  }
};
export const fetchUserPlanHistory = async (userId) => {
  try {
    const response = await CustomAxios.get(`/user-plans/${userId}/history`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user history. Please try again.");
  }
};
